import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { SERVER_ERRORS } from '../../../api/SERVER_ERRORS';
import { getAllPermissions, getUserForCreation, getUsers, postUser, putUser, getFacilities } from '../../../api/users/users.api';
import notifications from '../notification/actions';
import actions from './actions';

function* fetchUsers({ clientId = "", showInactive = false }) {
    try {
        const data = yield call(getUsers, { clientId, showInactive });
        yield put(actions.fetchUsersSuccess(data.users));
    } catch (error) {
        console.log(error);
    }
}

function* fetchAllPermissions({ scope }) {
    try {
        const data = yield call(getAllPermissions, { scope });
        yield put(actions.fetchAllPermissionsSuccess(data.permissions));
    } catch (error) {
        console.log(error);
    }
}

function* checkUserEmail({ email = "", clientId = "" }) {
    try {
        const data = yield call(getUserForCreation, { email, clientId });
        yield put(actions.checkUserEmailSuccess(data.user && data.user.userId ? data.user : { email }));
    } catch (error) {
        console.log(error);
    }
}
function* fetchUser({ userId, clientId }) {
    try {
        const data = yield call(getUsers, { userId, clientId });
        yield put(actions.fetchUserSuccess(data.user));
    } catch (error) {
        console.log(error);
    }
}

function* inactivateUser({ userId = null }) {
    try {
        // const userObj = yield call(getUsers, {userId});
        yield put(actions.inactivateUserSuccess());
    } catch (error) {
        console.log(error);
    }
}

function* saveUser({ userInfo, clientId }) {
    try {
        const data = yield call(userInfo.userId ? putUser : postUser, { user: userInfo, clientId });
        if (data.user) {
            if (data.user.permissions && data.user.permissions)
                yield all([
                    put(actions.fetchUsers({ clientId })),
                    put(notifications.createNotification({
                        message: 'User successfully ' + (userInfo.userId ? 'updated' : 'created'),
                        mainAction: actions.SAVE_USER_SUCCESS,
                        status: 'SUCCESS'
                    }))
                ]);
        } else {
            yield all([
                put(notifications.createNotification({
                    ...data[0],
                    mainAction: actions.POST_SCHEDULE_CHANGE_ERROR,
                }))
            ]);
        }
    } catch (error) {
        yield all([
            put(notifications.createNotification({
                code: SERVER_ERRORS.COULD_NOT_CREATE_USER,
                mainAction: actions.POST_SCHEDULE_CHANGE_ERROR,
            }))
        ]);
    }
}

function* fetchFacilities({ parentId }) {
    try {        
        const data = yield call(getFacilities, { parentId });
        console.log(data);
        yield put(actions.fetchFacilitiesSuccess(data.facilities));
    } catch (error) {
        console.log(error);
    }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.FETCH_USERS, fetchUsers),
        takeEvery(actions.FETCH_USER, fetchUser),
        takeEvery(actions.SAVE_USER, saveUser),
        takeEvery(actions.CHECK_USER_EMAIL, checkUserEmail),
        takeEvery(actions.FETCH_ALL_PERMISSIONS, fetchAllPermissions),
        takeEvery(actions.INACTIVATE_USER, inactivateUser),
        takeLatest(actions.FETCH_FACILITIES, fetchFacilities),
    ]);
}